import { Input } from '@creditornot/cb-input';
import React from 'react';
import { Field, useFormState } from 'react-final-form';
import { useIntl } from 'react-intl';

import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';

import { useRowOverrideContext } from './WithOverrideToggle';
import { BaseField } from './types';
import { useOfferOverridesContext } from '../../../context/OfferOverridesContext';
import { FormRowRenderer } from '../FormRowRenderer';
import { DisplayText, PreviewRowContainer, StyledInputContainer } from '../OfferDetailsFormFields.styles';
import { FormValues } from '../types';

export const PosId = ({ sidePanelMode, offer }: BaseField) => {
  const menuPermissions = useOfferingMenuPermissionsContext();
  const intl = useIntl();
  const { values } = useFormState<FormValues>();
  const { isOverrideToggleOn, isRowGroupEnabledForOverride } = useRowOverrideContext();
  const { maybeOverriddenOffer, getOfferAttrHasOverride } = useOfferOverridesContext();

  const isPosIdOverridden = getOfferAttrHasOverride('external_id');

  const fieldNameToUse = isOverrideToggleOn ? 'posIdOverride' : 'posId';
  const offerToUse = isOverrideToggleOn ? maybeOverriddenOffer : offer;

  const previewComponent = (
    <PreviewRowContainer>
      <DisplayText>{offerToUse?.external_id || '-'}</DisplayText>
    </PreviewRowContainer>
  );

  const editComponent = (
    <Field name={fieldNameToUse}>
      {field => (
        <StyledInputContainer>
          <Input
            {...field.input}
            placeholder={intl.formatMessage({ id: 'menu.pos-id-placeholder' })}
            autoFocus={!values[fieldNameToUse]}
          />
        </StyledInputContainer>
      )}
    </Field>
  );

  return (
    <FormRowRenderer
      hasContentEditPermission={menuPermissions.contentEdit}
      label={intl.formatMessage({ id: 'menu.pos-id' })}
      previewComponent={previewComponent}
      editComponent={editComponent}
      shouldDisplayCreateTag={!values[fieldNameToUse]}
      sidePanelMode={sidePanelMode}
      isOverridden={isPosIdOverridden}
      canBeOverridden={isRowGroupEnabledForOverride}
      offer={offerToUse}
    />
  );
};
